import { useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../auth/AuthContext.js';

/**
 * Gate authenticated routes. Rather than auto-redirecting (which loops on hosted-UI errors), show a
 * clear sign-in prompt (§32.1) and preserve the intended route as `returnTo` for a deep-link return
 * to the Performance Console.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status, login } = useAuth();
  const location = useLocation();

  if (status === 'authenticated') return <>{children}</>;

  const returnTo = `${location.pathname}${location.search}`;
  return (
    <main className="page center">
      <div className="card auth-gate">
        <h1>Sign in</h1>
        <p className="muted">You need to sign in to open the Control Center.</p>
        <button type="button" className="action--primary" onClick={() => void login(returnTo)}>
          Continue to sign in
        </button>
      </div>
    </main>
  );
}
